<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Pasajeros</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative">
          <div class="w-full w-md-auto md-flex-1">
            <div class="d-flex justify-content-between align-items-center justify-content-lg-start">
              <button type="button" class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters">
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-md-none">
                <button type="button" class="button-tooltip text-dark font-weight-bold m-0" v-b-tooltip.hover
                  title="Recargar" @click="loadData()">
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0">
            <div class="d-none d-md-flex">
              <button type="button" class="button-tooltip text-dark font-weight-bold" v-b-tooltip.hover title="Recargar"
                @click="loadData()">
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar placeholder="Buscar por nombre, celular o documento" @search="onSearch"
                @input="search = $event" class="flex-1" />

              <div class="text-right mt-2 mt-md-0">
                <b-button :to="{ name: 'config-passenger-create' }" variant="none"
                  class="button button-primary ml-md-2">Agregar</b-button>
              </div>
            </div>
          </section>

          <filter-menu :show="showFilters" @hide="showFilters = false" :options="filterOptions"
            :selectedOptionFilter="filters" @setFilters="setFilters"></filter-menu>
        </div>

        <div class="w-100 d-flex flex-wrap align-items-center mt-2" v-if="showFiltersList">
          <span v-for="(val, name) in filterList" v-bind:key="name" class="filter-item">
            {{ getFilterName(name, val) }}
            <button type="button" class="text-white p-0 bg-transparent border-0 ml-2" @click="deleteFilter(name)">
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="table-responsive mb-0 table-min-height">
        <table class="custom-table w-100">
          <thead>
            <tr>
              <th>
                Número <br />
                de documento
              </th>
              <th>
                Nombres <br />
                y Apellidos
              </th>
              <th>
                Número <br />
                de celular
              </th>
              <th>
                Tipo de <br />
                pasajero
              </th>
              <th>
                Descuento <br />
                aplicado
              </th>
              <th>Estado</th>
              <th class="pr-md-4">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="text-center">{{ getIdentifierType(o.identifier_type).label }} - {{ o.identifier_number || '-' }}</td>
              <td>{{ o.full_name }}</td>
              <td class="text-center">{{ o.phone_number ? `+${o.phone_number}` : '-' }}</td>
              <td class="text-center">{{ getPassengerType(o.passenger_type).label || "-" }}</td>
              <td class="text-center">{{ o.discount_value ? `${o.discount_value} ${getDiscountType(o.discount_type)}` : '-' }}</td>
              <td class="text-center">
                <span :class="`badge ${getStatus(o.status).color}`">{{
                  getStatus(o.status).label
                }}</span>
              </td>
              <td class="text-center d_option pr-md-3">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem @click="
                      $router.push({
                        name: 'config-passenger-edit',
                        params: { id: o.id },
                      })
                      " text="Editar" />
                    <DropdownItem :text="getStatus(o.status).action" @click="openChangeStatus(o)" />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination :total="total" :page="page" :page-size="pageSize" :pages="pages" :changePage="changePage"
          :changePageSize="changePageSize" />
      </div>
    </div>

    <ConfirmationModal :show="confirmationModal.show" @hide="closeConfirmationModal" :data="confirmationModal"
      @confirm="confirmModal" />
  </div>
</template>

<script>
import { PassengerService } from "@/core/services";
import { Constants as LocalConstants } from "@/core/utils";

import {
  Alert,
  Constants,
  Util,
  PaginationMixin,
  DropdownTable,
  DropdownItem,
  SearchBar,
  FilterMenu,
  FilterMixin,
  ConfirmationModal,
  ConfirmationModalMixin
} from "wize-admin";

export default {
  components: {
    SearchBar,
    FilterMenu,
    DropdownTable,
    DropdownItem,
    ConfirmationModal
  },
  mixins: [PaginationMixin, FilterMixin, ConfirmationModalMixin],
  data() {
    return {
      webUrl: process.env.VUE_APP_WEB_URL,
      list: [],
      tooltipType: null,
      filterOptions: [
        {
          label: "Tipo de documento",
          key: "identifier_type",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.PassengerIdentifierType.DNI,
            LocalConstants.PassengerIdentifierType.CE,
            LocalConstants.PassengerIdentifierType.PASSPORT,
          ],
        },
        {
          label: "Tipo de pasajero",
          key: "passenger_type",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.PassengerType.OCASIONAL,
            LocalConstants.PassengerType.REGULAR,
            LocalConstants.PassengerType.QORE,
            LocalConstants.PassengerType.FF,
            LocalConstants.PassengerType.CORPORATIVO,
          ],
        },
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.PassengerStatus.ACTIVE,
            LocalConstants.PassengerStatus.INACTIVE,
          ],
        }
      ],
    };
  },
  methods: {
    openChangeStatus(o) {
      this.selectedOption = o;
      this.openConfirmationModal({
        title: "Cambiar estado",
        description: "¿Está seguro que desea cambiar el estado?",
        acceptText: "Aceptar",
        action: "update",
      });
    },
    confirmModal() {
      this.closeConfirmationModal();
      if (this.confirmationModal.action === "update") this.changeStatus();
    },
    async changeStatus() {
      try {
        await this.$store.dispatch("app/loading", true);

        let status = this.selectedOption.status;
        if (status == LocalConstants.PassengerStatus.ACTIVE.key) {
          status = LocalConstants.PassengerStatus.INACTIVE.key;
        } else if (status == LocalConstants.PassengerStatus.INACTIVE.key) {
          status = LocalConstants.PassengerStatus.ACTIVE.key;
        }

        await PassengerService.changeStatus(this.selectedOption.id, status);
        await this.loadData();
        Alert.success("Estado actualizado correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getIdentifierType(key) {
      return Util.searchValue(key, LocalConstants.PassengerIdentifierType);
    },
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        const params = { page: this.page - 1, size: this.pageSize, sort: "id" };
        const data = { search: this.search, ...this.filters };

        const response = await PassengerService.list(data, params);
        this.list = JSON.parse(JSON.stringify(response.payload.items));
        this.total = response.payload?.metadata.totalElements;
        this.pages = response.payload?.metadata.totalPages;
      } catch (error) {
        console.error(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getStatus(key) {
      let keyInt = parseInt(key);
      return Util.searchValue(keyInt, LocalConstants.PassengerStatus);
    },
    getPassengerType(key) {
      return Util.searchValue(key, LocalConstants.PassengerType);
    },
    getDiscountType(key) {
      let int = parseInt(key);
      if (int == LocalConstants.CommissionOptions.PERCENTAGE.key) {
        return '%';
      } else if (int == LocalConstants.CommissionOptions.FIXED_AMOUNT.key) {
        return 'Monto fijo';
      }
      return '';
    },
  },
  async mounted() {
    await this.loadData();
  },
};
</script>

<style lang="stylus" scoped></style>
